export default __webpack_public_path__ + "static/media/silver.4c2ed9f0f9a517bf44e594377e610091.svg";